import React from "react"

export default function Location() {
  return (
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12794.825191856857!2d3.1716451!3d36.705595!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xd6e74be7191a6758!2sGDG%20Algiers!5e0!3m2!1sfr!2sdz!4v1581095013454!5m2!1sfr!2sdz"
      width="100%"
      height="100%"
      frameborder="0"
      title="wtm-location"
      style={{ border: 0, margin: 0 }}
      allowfullscreen=""
    ></iframe>
  )
}
